
import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
//import { Provider as ReduxProvider } from "react-redux";
//import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import Routes from "./routes/Routes";
import "./i18n";
import { RETRY_COUNT, EXPONENTIAL_BACKOFF } from "./constant";
import CleverTap from "./components/CleverTap/CleverTap";
import FbPixel from "./utils/FbPixel/fbPixel";
import { initializeUserIP } from "./utils/cleverTapHelper";

export const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: 60 * 1000,
        retry: RETRY_COUNT,
        retryDelay: (failureCount) =>
          (EXPONENTIAL_BACKOFF[failureCount] || 1) * 1000,
      },
    },
  });

const App: React.FC = () => {
  // Initialize user IP fetch on app load
  useEffect(() => {
    initializeUserIP();
  }, []);
  useEffect(() => {
    if (typeof (window as any).clevertap !== 'undefined') {
      (window as any).clevertap.notifications.push({
        "titleText": "Would you like to receive Push Notifications?",
        "bodyText": "We promise to only send you relevant content and give you updates on your transactions",
        "okButtonText": "Sign me up!",
        "rejectButtonText": "No thanks",
        "okButtonColor": "#F28046",
        "askAgainTimeInSeconds": 5,
        "serviceWorkerPath": "/service-worker.js"
      });
    }
  }, []);

  return (
      <main className="main">
        {/* Initialize CleverTap for web tracking */}
        <CleverTap accountId={process.env.REACT_APP_CLEVERTAP_PROJECT_ID || 'RK4-W7K-R67Z'} />
        {/* Initialize Facebook Pixel for all pages */}
        <FbPixel />
        <QueryClientProvider client={queryClient}>
          <Router>
            <Routes />
          </Router>
        </QueryClientProvider>
      </main>
  );
};

export default App;
